import Step from "@material-ui/core/Step";
import StepLabel from "@material-ui/core/StepLabel";
import Stepper from "@material-ui/core/Stepper";
import useText from "constants/text";
import { RegistrationProvider } from "contexts/Registration";
import React, { useState } from "react";
import ErrorMessage from "./Error";
import StepOneOfRegister from "./StepOneOfRegister";
import StepSecondOfRegister from "./StepSecondOfRegister";
import { useStyles } from "./styles";
import Success from "./Success";

export default function FormRegistration() {
  const [activeStep, setActiveStep] = useState(0);
  const { text } = useText();
  const styles = useStyles();

  function getSteps() {
    return [`${text.all.entreprise}`, `${text.all.representing}`];
  }
  const steps = getSteps();
  function getStepContent(stepIndex: number) {
    switch (stepIndex) {
      case 0:
        return <StepOneOfRegister onNext={setActiveStep} />;
      case 1:
        return <StepSecondOfRegister onNext={setActiveStep} onPrev={handleBack} />;
      default:
        return <ErrorMessage />;
    }
  }

  const handleBack = () => {
    setActiveStep((prevActiveStep) => prevActiveStep - 1);
  };

  return (
    <div>
      <div className={styles.title}>{text.all.self_registration}</div>
      <div className={styles.stepstyle}> 
      <Stepper activeStep={activeStep} alternativeLabel>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>
      </div>
      {activeStep === steps.length ? (
        <Success />
        ) : (
      <RegistrationProvider>
        {getStepContent(activeStep)}
      </RegistrationProvider>
        )}
    </div>
  );
}

